var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7915 11.5046H7.62148L12.5015 6.62461C12.8915 6.23461 12.8915 5.59461 12.5015 5.20461C12.1115 4.81461 11.4815 4.81461 11.0915 5.20461L4.50148 11.7946C4.11148 12.1846 4.11148 12.8146 4.50148 13.2046L11.0915 19.7946C11.4815 20.1846 12.1115 20.1846 12.5015 19.7946C12.8915 19.4046 12.8915 18.7746 12.5015 18.3846L7.62148 13.5046H18.7915C19.3415 13.5046 19.7915 13.0546 19.7915 12.5046C19.7915 11.9546 19.3415 11.5046 18.7915 11.5046Z",
    fill: "#0D1634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.d1175cf1242cca3a5160b1805c5096da.svg";
export { ForwardRef as ReactComponent };